import { Section } from '@shared/components/Section';
import { Etapas, Fases } from '@shared/components/moldes';
import { BotaoDeContato } from '@inscricao/components/Contato';
import { etapas, fasesDoCenario } from '@curso/content/etapas';

/**
 * Bloco 6. Responde: como as três partes se encaixam.
 *
 * Primeira repetição da chamada. Quem se convenceu aqui não precisa rolar
 * até o fim para encontrar uma saída.
 *
 * As três fases do cenário entram aqui dentro da terceira parte, e não como
 * lista própria. São duas sequências de três na mesma tela, e elas não são da
 * mesma natureza: uma é formato de entrega, a outra é passagem de tempo. Lado
 * a lado no mesmo recuo, o leitor pareia videoaula com preparar e sai com a
 * ideia errada. Dentro, lê como o que é: um zoom no fim de semana.
 *
 * A escala detalhada dos mesmos três momentos fica na aba do fim de semana.
 */
export function ComoFunciona() {
  const fimDeSemana = etapas.length - 1;

  return (
    <Section
      id="como-funciona"

      rotulo="Como funciona"
      titulo="Três etapas. Uma experiência de aprendizagem."
    >
      <p className="prosa mb-8">
        Você conhece os conceitos, discute sua aplicação e, por fim, coloca tudo à prova em
        cenários de alta pressão.
      </p>

      <Etapas
        itens={etapas}
        desdobramento={{
          indice: fimDeSemana,
          conteudo: (
            <>
              <p className="rotulo">Cada cenário, em três tempos</p>
              <div className="mt-4">
                <Fases itens={fasesDoCenario} />
              </div>
            </>
          ),
        }}
      />
      <div className="mt-10 border-t border-linha pt-8">
        <BotaoDeContato origem="como-funciona" />
      </div>
    </Section>
  );
}
